class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.addEventListener('click', (evt) => {
      const panel = this.querySelector('.ty-cart-panel');
      if (panel && !panel.contains(evt.target)) this.close();
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      // Masaüstünde normal sepet sayfasına git
      if (window.innerWidth >= 990) return;
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      if (window.innerWidth >= 990) return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);

    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    this.addEventListener(
      'transitionend',
      () => {
        const focusTarget = document.getElementById('CartDrawer') || this.querySelector('.drawer__inner');
        const focusEl = this.querySelector('.drawer__close') || this.querySelector('.ty-cart-panel__close');
        if (focusTarget && typeof trapFocus === 'function') trapFocus(focusTarget, focusEl);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    setTimeout(() => this.classList.remove('animate'), 350);
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling?.id)
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (window.innerWidth >= 990) {
      window.location = window.routes ? window.routes.cart_url : '/cart';
      return;
    }

    this.productId = parsedState.id;

    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        const el = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!el) return;
        const html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        if (html != null) el.innerHTML = html;
      });
    }

    if (typeof parsedState.item_count === 'number') {
      this.updateCartCount(parsedState.item_count);
    } else {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => this.updateCartCount(cart.item_count))
        .catch(() => {});
    }

    const itemsEl = this.querySelector('.ty-cart-panel__items');
    const emptyState = this.querySelector('.ty-cart-panel__empty-state');
    const footerEl = this.querySelector('#CartDrawer-Footer');
    const drawerItems = this.querySelector('cart-drawer-items');

    const hasItems = itemsEl && itemsEl.querySelectorAll('.ty-cart-item').length > 0;

    this.classList.toggle('is-empty', !hasItems);
    if (drawerItems) drawerItems.classList.toggle('is-empty', !hasItems);
    if (emptyState) emptyState.classList.toggle('hidden', hasItems);
    if (itemsEl) itemsEl.classList.toggle('hidden', !hasItems);
    if (footerEl) footerEl.classList.toggle('hidden', !hasItems);

    // Overlay — mevcut listener'ı kaldırıp yeniden bağla
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.replaceWith(overlay.cloneNode(true));
      const newOverlay = this.querySelector('#CartDrawer-Overlay');
      if (newOverlay) newOverlay.addEventListener('click', this.close.bind(this));
    }

    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }];
  }

  updateCartCount(count) {
    const countEl = document.querySelector('.ty-header__cart-count, #cart-count');
    if (countEl) countEl.textContent = count;

    const bubbleSpan = document.querySelector('.cart-count-bubble span[aria-hidden]');
    if (bubbleSpan) bubbleSpan.textContent = count;

    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) bubble.style.display = count > 0 ? '' : 'none';
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      // Masaüstünde drawer güncelleme yapma — sayfa zaten yönleniyor
      if (window.innerWidth >= 990) return;
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
